import React from "react";

/**
 * MicButton
 *
 * Props:
 *  - isListening  {boolean}  – whether the mic is active (drives the pulse)
 *  - isSupported  {boolean}  – browser support flag; button is disabled when false
 *  - disabled     {boolean}  – extra disabled flag (e.g. while sending)
 *  - onClick      {function} – called when the button is clicked
 */
const MicButton = ({ isListening, isSupported, disabled, onClick }) => {
    const title = !isSupported
        ? "Voice input not supported in this browser"
        : isListening
            ? "Stop listening"
            : "Click to speak";

    return (
        <>
            <style>{`
                @keyframes mic-pulse {
                    0%   { box-shadow: 0 0 0 0   rgba(220, 53, 69, 0.5); }
                    70%  { box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);   }
                    100% { box-shadow: 0 0 0 0   rgba(220, 53, 69, 0);   }
                }
                .mic-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    border: none;
                    cursor: pointer;
                    transition: background-color 0.2s, transform 0.15s;
                    outline: none;
                    flex-shrink: 0;
                }
                .mic-btn:not(:disabled):hover {
                    transform: scale(1.1);
                }
                .mic-btn:disabled {
                    cursor: not-allowed;
                    opacity: 0.5;
                }
                .mic-btn.listening {
                    background-color: #dc3545;
                    animation: mic-pulse 1.2s infinite;
                }
                .mic-btn.idle {
                    background-color: #0ab39c;
                }
                .mic-btn svg {
                    width: 18px;
                    height: 18px;
                    fill: #ffffff;
                }
            `}</style>

            <button
                type="button"
                title={title}
                aria-label={title}
                className={`mic-btn ${isListening ? "listening" : "idle"}`}
                disabled={!isSupported || disabled}
                onClick={onClick}
            >
                {/* Microphone icon (inline SVG – no extra library needed) */}
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1a4 4 0 0 1 4 4v6a4 4 0 0 1-8 0V5a4 4 0 0 1 4-4zm6 9a1 1 0 0 1 2 0 8 8 0 0 1-7 7.94V20h2a1 1 0 0 1 0 2H9a1 1 0 0 1 0-2h2v-2.06A8 8 0 0 1 4 10a1 1 0 0 1 2 0 6 6 0 0 0 12 0z" />
                </svg>
            </button>
        </>
    );
};

export default MicButton;
